import { KnowledgeBaseArticleContentType, KnowledgeBaseArticleMaterialCategory } from 'types/KnowledgeBase';
import toolIcon, { ReactComponent as ToolIconSvg } from 'assets/icons/categories/tool.svg';
import knowledgeIcon, { ReactComponent as KnowledgeIconSvg } from 'assets/icons/new/file-book.svg';
import pdfIcon, { ReactComponent as PdfIconSvg } from 'assets/icons/categories/pdf.svg';
import videoIcon, { ReactComponent as VideoIconSvg } from 'assets/icons/categories/video.svg';
import formIcon, { ReactComponent as FormIconSvg } from 'assets/icons/categories/form.svg';
import otherIcon, { ReactComponent as OtherIconSvg } from 'assets/icons/categories/other.svg';

export const getKnowledgeBaseArticleIconSvg = (
	cat: KnowledgeBaseArticleMaterialCategory | null,
	type: KnowledgeBaseArticleContentType
) => {
	if (cat) {
		switch (cat) {
			case KnowledgeBaseArticleMaterialCategory.KNOWLEDGE:
				return KnowledgeIconSvg;
			case KnowledgeBaseArticleMaterialCategory.PDF:
				return PdfIconSvg;
			case KnowledgeBaseArticleMaterialCategory.VIDEO:
				return VideoIconSvg;
			case KnowledgeBaseArticleMaterialCategory.TOOL:
			case KnowledgeBaseArticleMaterialCategory.EXERCISE:
				return ToolIconSvg;
			case KnowledgeBaseArticleMaterialCategory.FORM:
				return FormIconSvg;
			case KnowledgeBaseArticleMaterialCategory.OTHER:
			case KnowledgeBaseArticleMaterialCategory.NOTE:
				return OtherIconSvg;
			default:
				return OtherIconSvg;
		}
	}

	switch (type) {
		case KnowledgeBaseArticleContentType.VIDEO:
			return VideoIconSvg;
		case KnowledgeBaseArticleContentType.PDF:
			return PdfIconSvg;
		case KnowledgeBaseArticleContentType.FORM:
			return FormIconSvg;
		default:
			return OtherIconSvg;
	}
};

export const getKnowledgeBaseArticleIcon = (
	cat: KnowledgeBaseArticleMaterialCategory | null,
	type: KnowledgeBaseArticleContentType
) => {
	if (cat) {
		switch (cat) {
			case KnowledgeBaseArticleMaterialCategory.KNOWLEDGE:
				return knowledgeIcon;
			case KnowledgeBaseArticleMaterialCategory.PDF:
				return pdfIcon;
			case KnowledgeBaseArticleMaterialCategory.VIDEO:
				return videoIcon;
			case KnowledgeBaseArticleMaterialCategory.TOOL:
			case KnowledgeBaseArticleMaterialCategory.EXERCISE:
				return toolIcon;
			case KnowledgeBaseArticleMaterialCategory.FORM:
				return formIcon;
			case KnowledgeBaseArticleMaterialCategory.OTHER:
			case KnowledgeBaseArticleMaterialCategory.NOTE:
				return otherIcon;
			default:
				return otherIcon;
		}
	}

	switch (type) {
		case KnowledgeBaseArticleContentType.VIDEO:
			return videoIcon;
		case KnowledgeBaseArticleContentType.PDF:
			return pdfIcon;
		case KnowledgeBaseArticleContentType.FORM:
			return formIcon;
		default:
			return otherIcon;
	}
};
